import { render, staticRenderFns } from "./money.vue?vue&type=template&id=0dd702f9&scoped=true&"
import script from "./money.vue?vue&type=script&lang=js&"
export * from "./money.vue?vue&type=script&lang=js&"
import style0 from "./money.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./money.vue?vue&type=style&index=1&id=0dd702f9&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0dd702f9",
  null
  
)

export default component.exports